var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDriverSelectNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.668 16.001c0-7.364 5.97-13.333 13.333-13.333 7.364 0 13.334 5.97 13.334 13.333 0 7.364-5.97 13.334-13.334 13.334S2.668 23.365 2.668 16zm10.276-4.943a1.333 1.333 0 1 0-1.886 1.886l3.058 3.057-3.057 3.057a1.333 1.333 0 1 0 1.885 1.886l3.057-3.057 3.057 3.057a1.333 1.333 0 1 0 1.886-1.886l-3.057-3.057 3.057-3.057a1.333 1.333 0 1 0-1.886-1.886l-3.057 3.058-3.057-3.057z",
    fill: "#818B9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDriverSelectNo);
export default __webpack_public_path__ + "static/media/icon_driver-select-no.be5ec7ed81bec9d78afe53a44c0ae98b.svg";
export { ForwardRef as ReactComponent };